import React, { forwardRef } from 'react';

interface LabelTextProps extends React.HTMLAttributes<HTMLDivElement> {
  text: string;
  add_margin?: boolean;
  class_name?: string;
}

const LabelText = forwardRef<HTMLDivElement, LabelTextProps>(
  ({ text, class_name = '', add_margin = false, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={`text-[1.4rem] leading-[1.6rem] font-semibold ${
          add_margin ? 'mb-[0.6rem]' : ''
        } ${class_name}`}
        {...props}
      >
        {text}
      </div>
    );
  },
);

LabelText.displayName = 'LabelText';

export default LabelText;
